<template lang="pug">
  .form-enter-product
    .input-container
      label.label Enter Code
      input.input(v-model="code" @keydown.enter="processCode()" autocomplete="ño")
    div Current Tier:
      span.uppercase  {{ currentTier }}
    div Total: {{ totalProducts }}

    div(v-for="(item, product) in stock")
      h3.uppercase.title-product {{ product }}
      div(v-for="(size, index) in item.sizes")
        h4.title-size Size: {{ ' ' }}
          span.uppercase {{ size }}
        div Quantity: {{item.quantity[index]}}
        h5.title-tier  Tiers: {{ ' ' }}
        .tiers-container
          .tier-container(v-for="(tier, indexT) in item.tiers[index]" @click="deleteTier(product, index, indexT)") {{ tier }}

    button.button.button-form.bg-principal.color-black(@click="saveStock") Save Stock
</template>

<script>
import mForm from '@/mixins/form'
import { normalizeScanCode, stripScanPrefix } from '@/helpers/scanCode'

export default {
  name: 'EnterProducts',

  mixins: [mForm],

  data () {
    return {
      stock: {},
      code: '',
      currentTier: '',
      sounds: {
        beepError: 'beep_error.mp3',
        beep: 'beep.mp3',
        error: 'error.mp3',
        tier: 'tier.mp3',
        product: 'product.mp3'
      }
    }
  },

  methods: {
    saveStock () {
      console.log(JSON.stringify(this.stock))
    },

    processCode () {
      const code = normalizeScanCode(this.code)
      const tier = this.currentTier

      if (!code) {
        this.playSoundError()
        return
      }

      if (code[0] === '-') {
        const tier = stripScanPrefix(code)
        if (tier) {
          this.setTier(tier)
        } else {
          this.playSoundError()
        }
      } else {
        const productSplit = code.split('-')

        if (productSplit.length !== 2) {
          this.playSoundError()
        } else {
          const nameProduct = productSplit[0]
          const size = productSplit[1]

          if (nameProduct && size && tier) {
            this.enterProduct(nameProduct, size, tier)
          } else {
            this.playSoundError()
          }
        }
      }

      this.code = ''
    },

    setTier (tier) {
      this.currentTier = tier
      this.playSoundTier()
    },

    enterProduct (nameProduct, size, tier) {
      const stock = this.stock

      if (!stock[nameProduct]) this.$set(stock, nameProduct, {})

      this.pushQuantity(stock[nameProduct], size, tier)
      this.playSoundProduct()
    },

    pushQuantity (product, size, tier, quantity = 1) {
      if (!product.sizes) {
        this.$set(product, 'sizes', [])
        this.$set(product, 'quantity', [])
        this.$set(product, 'tiers', [])
      }

      if (product.sizes.length === 0) {
        product.sizes.push(size)
        product.quantity.push(quantity)
        product.tiers.push(Array(quantity).fill(tier))
      } else {
        const position = this.sizePosition(product.sizes, size)

        if (position < 0) {
          product.sizes.push(size)
          product.quantity.push(quantity)
          product.tiers.push(Array(quantity).fill(tier))
        } else {
          const previusQuantity = product.quantity[position] || 0
          const previusTier = product.tiers[position] || []

          this.$set(product.quantity, position, previusQuantity + quantity)
          this.$set(product.tiers, position, previusTier.concat(tier))
        }
      }
    },

    sizePosition (sizes, size) {
      return sizes.findIndex(element => element === size)
    },

    playSoundTier () {
      this.playSound(this.sounds.beep)
      this.playSound(this.sounds.tier)
    },

    playSoundProduct (sound) {
      this.playSound(this.sounds.beep)
      this.playSound(this.sounds.product)
    },

    playSoundError () {
      this.playSound(this.sounds.beepError)
      this.playSound(this.sounds.error)
    },

    deleteTier (productName, index, indexTier) {
      const product = this.stock[productName]

      if (product) {
        const previusQuantity = product.quantity[index]

        if (previusQuantity - 1 === 0) {
          product.sizes.splice(index, 1)
          product.quantity.splice(index, 1)
          product.tiers.splice(index, 1)
        } else {
          this.$set(product.quantity, index, previusQuantity - 1)
          product.tiers[index].splice(indexTier, 1)
        }

        if (product.sizes.length === 0) delete this.stock[productName]
      }
    }
  },

  computed: {
    totalProducts () {
      let total = 0

      for (const key in this.stock) {
        if (Object.hasOwnProperty.call(this.stock, key)) {
          const product = this.stock[key]
          const quantity = product.quantity

          total += quantity.reduce((subtotal, element) => subtotal + element, 0)
        }
      }

      return total
    }
  }
}
</script>

<style lang="stylus">
.form-enter-product
  position relative

.title-product
  margin 2em 0 0 0

.title-size, .title-tier
  font-size 1.2em
  margin .5em 0

.title-size
  margin-top 1em

.tiers-container
  display inline-flex
  flex-wrap wrap

.tier-container
  border 1px solid #FFDC65
  border-radius 100%
  height 2em
  width 2em
  margin 0 .5em .5em 0
  padding-top .3em
  cursor pointer

</style>



// WEBPACK FOOTER //
// src/components/pages/stock/Enter.vue